import React from 'react'

import { FacebookIcon, InstagranIcon, YoutubeIcon } from '../Icons/Icons';

const SocialMedia = () => {
  return (
    <div className="flex justify-center gap-4 py-2 text-white">
    <a target="_blank" rel="noopener noreferrer" className="inline-flex cursor-pointer p-[.4rem] text-inherit no-underline transition duration-200 hover:-translate-y-0.5 hover:text-focus motion-reduce:transform-none motion-reduce:transition-none" href='https://youtube.com/@vismal' aria-label="Vismal on YouTube">
      <YoutubeIcon />
    </a>
    <a target="_blank" rel="noopener noreferrer" className="inline-flex cursor-pointer p-[.4rem] text-inherit no-underline transition duration-200 hover:-translate-y-0.5 hover:text-focus motion-reduce:transform-none motion-reduce:transition-none" href='https://www.facebook.com/profile.php?id=100066856882210' aria-label="Vismal on Facebook">
      <FacebookIcon />
    </a>
    <a target="_blank" rel="noopener noreferrer" className="inline-flex cursor-pointer p-[.4rem] text-inherit no-underline transition duration-200 hover:-translate-y-0.5 hover:text-focus motion-reduce:transform-none motion-reduce:transition-none" href='https://www.instagram.com/vismalmetal/' aria-label="Vismal on Instagram">
      <InstagranIcon />
    </a>
  </div>
  )
}

export default SocialMedia
